import { Reveal } from "@components/ui";

const afterEmergencyItems = [
  "Do NOT relight or restart any gas system",
  "Wait for GASIS technicians to assess the site",
  "Allow full testing and clearance",
  "Receive confirmation SMS/email before using gas again",
  "Log in to your portal to view the safety report",
];

const firePreventionItems = [
  "Install smoke and gas detectors (recommended by Civil Defense)",
  "Keep fire extinguishers (Class B/C) accessible",
  "Train household members or staff on how to close gas valves",
  "Avoid overfilling pots (boil-overs can extinguish gas flame)",
  "Ensure chimney/flue exhausts are open when using gas heaters",
];

export function PostEmergencySection() {
  return (
    <section className="w-full bg-[#f5f5f7] overflow-hidden px-5 md:px-10 lg:px-[180px] py-12 md:py-16 lg:py-[100px]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col lg:flex-row gap-6 md:gap-8">
        {/* Card A: After Emergency */}
        <Reveal direction="up" className="w-full lg:flex-1">
          <div className="h-full rounded-[20px] bg-white p-6 md:p-8 lg:p-10 flex flex-col gap-6 md:gap-8 shadow-[0_2px_12px_rgba(0,0,0,0.04)]">
            {/* Header */}
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-[14px] bg-[#f24d2b]/10 flex items-center justify-center shrink-0">
                <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 md:w-6 md:h-6">
                  <path d="M12 9v4M12 17h.01" stroke="#f24d2b" strokeWidth="1.5" strokeLinecap="round" />
                  <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="#f24d2b" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h2 className="text-[20px] md:text-[26px] lg:text-[30px] font-semibold tracking-[-0.04em] text-[#122d63] leading-[1.15]">
                After an Emergency Leak
              </h2>
            </div>

            {/* Items */}
            <div className="flex flex-col gap-2.5 md:gap-3">
              {afterEmergencyItems.map((item, index) => (
                <div
                  key={index}
                  className="flex items-start gap-3 p-3 md:p-3.5 rounded-[12px] bg-[#f8f9fb]"
                >
                  <div className="w-6 h-6 rounded-full bg-[#f24d2b]/10 flex items-center justify-center shrink-0 mt-0.5">
                    <span className="text-[11px] font-bold text-[#f24d2b]">
                      {index + 1}
                    </span>
                  </div>
                  <p className="text-[13px] md:text-[16px] lg:text-[17px] tracking-[-0.03em] text-[#4a4b52] leading-[1.5]">
                    {item}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        {/* Card B: Fire Prevention */}
        <Reveal direction="up" className="w-full lg:flex-1">
          <div className="h-full rounded-[20px] bg-white p-6 md:p-8 lg:p-10 flex flex-col gap-6 md:gap-8 shadow-[0_2px_12px_rgba(0,0,0,0.04)]">
            {/* Header */}
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-[14px] bg-[#ff8c00]/10 flex items-center justify-center shrink-0">
                <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 md:w-6 md:h-6">
                  <path d="M12 22c3.5 0 6-2.5 6-6 0-4-3-7-6-10-3 3-6 6-6 10 0 3.5 2.5 6 6 6z" stroke="#ff8c00" strokeWidth="1.5" />
                  <path d="M10 17a2 2 0 104 0" stroke="#ff8c00" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
              </div>
              <h2 className="text-[20px] md:text-[26px] lg:text-[30px] font-semibold tracking-[-0.04em] text-[#122d63] leading-[1.15]">
                Fire & Explosion Prevention
              </h2>
            </div>

            {/* Items */}
            <div className="flex flex-col gap-2.5 md:gap-3">
              {firePreventionItems.map((item, index) => (
                <div
                  key={index}
                  className="flex items-start gap-3 p-3 md:p-3.5 rounded-[12px] bg-[#f8f9fb]"
                >
                  <div className="w-5 h-5 rounded-full bg-[#ff8c00]/15 flex items-center justify-center shrink-0 mt-0.5">
                    <svg viewBox="0 0 12 12" className="w-3 h-3">
                      <path d="M10 3L4.5 8.5 2 6" stroke="#ff8c00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <p className="text-[13px] md:text-[16px] lg:text-[17px] tracking-[-0.03em] text-[#4a4b52] leading-[1.5]">
                    {item}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
